import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useRef, useState } from "react";
import clsx from "clsx";
import { Button } from "catalyst/button";
import { ErrorMessage, Field } from "catalyst/fieldset";
import { Input } from "catalyst/input";
import { Text } from "catalyst/text";
export function InlineNameEditor({ label, value, displayValue = value, editable = true, disabled = false, defaultEditing = false, maxLength, className, onSave, }) {
    const [draft, setDraft] = useState(() => defaultEditing && editable ? (value.trim() ? value : "") : null);
    const editing = draft !== null;
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState(null);
    const editButton = useRef(null);
    const restoreFocus = useRef(false);
    useEffect(() => {
        if (!editing && restoreFocus.current) {
            editButton.current?.focus();
            restoreFocus.current = false;
        }
    }, [editing]);
    const close = () => {
        restoreFocus.current = true;
        setDraft(null);
        setError(null);
    };
    return (_jsxs("form", { "aria-label": label, className: clsx("grid min-w-0 gap-x-3 gap-y-2 lg:grid-cols-[minmax(0,1fr)_auto]", editing
            ? "grid-cols-[auto_1fr] items-start"
            : "grid-cols-[minmax(0,1fr)_auto] items-center", className), onSubmit: async (event) => {
            event.preventDefault();
            if (draft === null || !editable || disabled || saving)
                return;
            setSaving(true);
            setError(null);
            try {
                await onSave(draft.trim());
                close();
            }
            catch (reason) {
                setError(reason instanceof Error ? reason.message : String(reason));
            }
            finally {
                setSaving(false);
            }
        }, children: [editing ? (_jsxs("div", { className: "contents lg:grid lg:min-w-0 lg:grid-cols-[minmax(0,1fr)_auto] lg:items-start lg:gap-x-3", children: [_jsxs(Field, { className: "col-span-full min-w-0 lg:col-span-1", children: [_jsx(Input, { autoFocus: true, "aria-label": label, value: draft, disabled: saving || disabled || !editable, maxLength: maxLength, invalid: error !== null, onChange: (event) => setDraft(event.target.value), onKeyDown: (event) => {
                                    if (event.key === "Escape" && !saving && !disabled) {
                                        event.preventDefault();
                                        close();
                                    }
                                } }), error && _jsx(ErrorMessage, { role: "alert", children: error })] }), _jsx(Button, { type: "submit", disabled: saving || disabled, className: "justify-self-start", children: saving ? "Сохраняем…" : "Сохранить" }, "save")] })) : (_jsx(Text, { className: "min-w-0 truncate", children: displayValue })), editable && (_jsx(Button, { ref: editing ? undefined : editButton, type: "button", plain: true, disabled: saving || disabled, className: "justify-self-start", onClick: () => {
                    if (editing)
                        close();
                    else {
                        setDraft(value.trim() ? value : "");
                        setError(null);
                    }
                }, children: editing ? "Отмена" : "Изменить" }, editing ? "cancel" : "edit"))] }));
}
